import {Component, Input, OnInit} from '@angular/core';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsNotificationType} from '../../../models/sts-notification-type';
import {StsRegistrationType} from '../../../models/sts-registration-type.enum';
import { ActivatedRoute, Router } from '@angular/router';
import {StsA360RegServicesService} from '../../../services/sts-a360-reg-services.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import StsA360NotificationTokenModel from 'app/models/sts-a360-notification-token.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-account-reg-wrong-postal-code',
  templateUrl: './account-reg-wrong-postal-code.component.html',
  styleUrls: ['./account-reg-wrong-postal-code.component.scss']
})

export class AccountRegWrongPostalCodeComponent implements OnInit {


  public errors: StsNotification[] = [];
  public mode: StsRegistrationType = StsRegistrationType.Registration;
  public id: string = '';
  public token: StsA360NotificationTokenModel;
  public tokenSubscription: Observable<StsA360NotificationTokenModel>=null;
  message: StsA360NotificationTokenModel;
  public emailSent = false;

  constructor(private httpClient: HttpClient,
    private router: Router,
    private regService: StsA360RegServicesService) {
   }

  ngOnInit() {
    this.regService.currentMessage.subscribe(message => this.message = message)
  }

  generateEmail(){
       this.regService.wrongPostalCode(this.message).subscribe(
        r => {
          this.emailSent=true;
        },
        errorRes => {
          console.log('error');
        }
      );
      this.emailSent=true;
  }

  showErrors(errs: StsNotification[]): void {
    this.errors = errs;
  }
}
